import React, { lazy, Suspense } from "react";

// Lazy-load GameFrame so the egg code is kept out of the homepage bundle
// until a signed-in user actually triggers the sequence.
const GameFrame = lazy(() => import("./GameFrame"));

const Launcher = ({ active, onExit }) => {
  if (!active) return null;
  return (
    <Suspense fallback={null}>
      <GameFrame onExit={onExit} />
    </Suspense>
  );
};

export default Launcher;
